import { validateCsvData } from './validateTransferOrderCsvData';

export default validateCsvData;
